import types from './types';

const INITIAL_STATE = {
  isFetching: false,
  isSaving: false,

  result: [],
};

const eligibilityLMPReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_LMP_DATE_REQUEST:
      return {
        ...state,
        result: [],
        isFetching: true,
      };

    case types.GET_LMP_DATE_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetching: false,
      };

    case types.GET_LMP_DATE_FAILURE:
      return {
        ...state,
        result: [],
        isFetching: false,
      };

    case types.SAVE_LMP_DATE_REQUEST:
      return {
        ...state,
        result: [],
        isSaving: true,
      };

    case types.SAVE_LMP_DATE_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isSaving: false,
      };

    case types.SAVE_LMP_DATE_FAILURE:
      return {
        ...state,
        result: [],
        isSaving: false,
      };

    default:
      return state;
  }
};

export default eligibilityLMPReducer;
